<mat-tab-group
  mat-stretch-tabs="false"
  mat-align-tabs="start"
  animationDuration="250ms"
  class="custom-mat-tab size-l"
  [class.hide-header]="shouldHideTabHeader()"
>
  @if (shouldShowAllMarkGroups()) {
    <mat-tab>
      <ng-template mat-tab-label>
        <span>All mark groups</span>
      </ng-template>
      <div class="flex flex-col">
        @for (markGroup of formCtrl().controls.all_mark_groups.controls; track $index) {
          <dojo-markscheme-markgroup-form-viewer
            [formCtrl]="markGroup"
            [isActive]="activeFormGroupItem()?.ctrl === markGroup"
            (setActive)="setActiveMarkGroupFormGroupItem(markGroup, $index)"
            [disabled]="disabled()"
            [isAllowedToEditImage]="editingOptions().allowImageEditing.length > 0"
            [editingOptions]="editingOptions()"
            (setActiveAndEditItem)="handleSetActiveAndEditItem($event, $index)"
            class="border-b border-neutral-200 py-3 last:border-0"
          />
        }

        @if (allowSolutionPathGeneration()) {
          <div class="flex justify-between p-4">
            <dojo-button
              [size]="'xs'"
              [fill]="state.formCtrlErrors ? 'solid' : 'outline'"
              [customColor]="state.formCtrlErrors ? 'red' : 'neutral'"
              (click)="generateSolutionPaths.emit()"
            >
              <div class="flex w-full items-center justify-between">
                <span>Generate Solution Paths</span>
                @if (state.formCtrlErrors) {
                  <dojo-icon
                    [icon]="'info-circle'"
                    class="ml-1.5"
                    [matTooltip]="'Generate after editing mark groups'"
                  />
                } @else {
                  <dojo-icon [icon]="'arrow-rotate-left'" class="ml-1.5" />
                }
              </div>
            </dojo-button>

            <dojo-button [size]="'xs'" [fill]="'outline'" [customWidth]="96" (click)="addNewMarkGroup()">
              <div class="flex w-full items-center justify-between">
                <span>Add MG</span>
                <dojo-icon [icon]="'add'" class="ml-1.5" />
              </div>
            </dojo-button>
          </div>
        }
      </div>
    </mat-tab>
  }

  @if (shouldShowSolutionPaths()) {
    @for (solutionPath of formCtrl().controls.solution_paths.controls; track $index; let solutionPathIndex = $index) {
      <mat-tab>
        <ng-template mat-tab-label>
          <span>Solution Path {{ $index + 1 }}</span>
        </ng-template>
        <div class="flex flex-col">
          @for (markGroup of state.markGroupsBySolutionPathIndex[solutionPathIndex]; track $index) {
            <dojo-markscheme-markgroup-form-viewer
              [formCtrl]="markGroup.control"
              [isActive]="activeFormGroupItem()?.ctrl === markGroup.control"
              (setActive)="setActiveMarkGroupFormGroupItem(markGroup.control, markGroup.allMarkGroupsIndex)"
              [disabled]="disabled()"
              [isAllowedToEditImage]="editingOptions().allowImageEditing.length > 0"
              [editingOptions]="editingOptions()"
              (setActiveAndEditItem)="handleSetActiveAndEditItem($event, markGroup.allMarkGroupsIndex)"
              class="border-b border-neutral-200 py-3 last:border-0"
            />
          }
          @if (solutionPath.controls.worked_solution.controls.length > 0) {
            <div class="flex w-full gap-3 p-4">
              <div class="w-full flex-1 overflow-x-auto overflow-y-hidden">
                <dojo-content-item-viewer
                  [contentItemsFormArray]="solutionPath.controls.worked_solution"
                  [isAllowedToEditImage]="editingOptions().allowImageEditing.length > 0"
                  [isAllowedToEditTable]="
                    editingOptions().allowImageEditing.length > 0 || editingOptions().allowMarkschemeEditing
                  "
                  (editItem)="
                    setActiveWorkedSolutionFormGroupItem(solutionPath.controls.worked_solution, solutionPathIndex);
                    editWorkedSolutionContentItem($event)
                  "
                />
              </div>
              @if (!editingOptions().hideBadges || editingOptions().allowMarkschemeEditing) {
                <dojo-selector-badge
                  class="self-start"
                  (clicked)="
                    setActiveWorkedSolutionFormGroupItem(solutionPath.controls.worked_solution, solutionPathIndex)
                  "
                  [disabled]="disabled()"
                  [color]="MARKSCHEME_ITEM_TYPE_TO_COLOR[MarkschemeEditorItemEnum.WorkedSolution]"
                  [label]="MARKSCHEME_ITEM_TYPE_TO_SHORT_LABEL[MarkschemeEditorItemEnum.WorkedSolution]"
                  [longLabel]="MARKSCHEME_ITEM_TYPE_TO_LONG_LABEL[MarkschemeEditorItemEnum.WorkedSolution]"
                  [active]="activeFormGroupItem()?.ctrl === solutionPath.controls.worked_solution"
                  [matTooltip]="MARKSCHEME_ITEM_TYPE_TO_LONG_LABEL[MarkschemeEditorItemEnum.WorkedSolution]"
                />
              }
            </div>
          }
        </div>
      </mat-tab>
    }
  }
</mat-tab-group>
